import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import moment from "moment";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import { FormattedMessage } from "react-intl";

const containerStyle = {
  width: "100%",
  height: "60vh",
};

function CheckInMap(props) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAT2egybpzhZipgC2X-M1u0xtQ1XfxIWCI",
  });
  const [map, setMap] = React.useState(null);
  const mapRef = React.useRef(null);
  const [center, setCenter] = useState({
    lat: props.markerPoints[0].position.lat,
    lng: props.markerPoints[0].position.lng,
  });

  useEffect(() => {
    setCenter({
      lat: props.markerPoints[0].position.lat,
      lng: props.markerPoints[0].position.lng,
    });
  }, [props.markerPoints]);

  const onLoad = React.useCallback(
    function callback(nMap) {
      const bounds = new window.google.maps.LatLngBounds(center);
      props.markerPoints.map((item) => {
        bounds.extend(item.position);
        return item.id;
      });
      nMap.fitBounds(bounds);
      setMap(nMap);
      return map;
    },
    [props.markerPoints, center, map]
  );

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  const showMarkers = () => {
    return props.markerPoints.map((marker, i) => {
      var markerIcon = marker.isCheckIn
        ? "img/MapsPinGreen.png"
        : "img/MapsPinRed.png";
      var markerTitle = marker.isCheckIn ? "Incheckning: " : "Utcheckning: ";
      markerTitle += moment(marker.time).format("HH:mm");
      return (
        <Marker
          key={"marker" + i}
          title={markerTitle}
          icon={markerIcon}
          position={{ lat: marker.position.lat, lng: marker.position.lng }}
        />
      );
    });
  };

  return isLoaded ? (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      style={{ maxWidth: "65vw", marginTop: "25vh" }}
    >
      <ModalBody style={{ border: "none", padding: "0" }}>
        <Row style={{ marginLeft: "0", marginRight: "0" }}>
          <Col lg={9} style={{ padding: "0" }}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              ref={mapRef}
              center={center}
              zoom={10}
              onLoad={onLoad}
              onUnmount={onUnmount}
            >
              {showMarkers()}
            </GoogleMap>
          </Col>
          <Col lg={3}>
            <Row style={{ marginTop: ".5em" }}>
              <Col
                xl={5}
                lg={12}
                style={{
                  paddingLeft: "1em",
                  paddingRight: "0",
                }}
              >
                <p className="lead mb-0" style={{ fontSize: "1vmax" }}>
                  <FormattedMessage id="CheckIns" />:
                </p>
                {props.checkIns.map((ci, i) => {
                  return (
                    <Row key={"ci" + i}>
                      <Col>{moment(ci.time).format("HH:mm")}</Col>
                    </Row>
                  );
                })}
              </Col>
              <Col
                xl={5}
                lg={12}
                style={{
                  paddingLeft: "1em",
                  paddingRight: "0",
                }}
              >
                <p className="lead mb-0" style={{ fontSize: "1vmax" }}>
                  <FormattedMessage id="CheckOuts" />:
                </p>
                {props.checkOuts.map((co, i) => {
                  return (
                    <Row key={"co" + i}>
                      <Col>{moment(co.time).format("HH:mm")}</Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  ) : (
    <></>
  );
}

export default React.memo(CheckInMap);
